module.exports = __webpack_public_path__ + "PR3-28aa9941.webp";